export default __webpack_public_path__ + "static/media/small_head_-7.1d68076b.webp";